import 'regenerator-runtime/runtime';
import {all} from 'redux-saga/effects';
import {appSagasWatchers} from '../app/sagas';
import {fetchApiRoutesSaga, fetchClientRoutesSaga} from '../routes/sagas';
import {fetchLocalisationsSaga} from '../locale/sagas';
import {formsFetchConfigsSaga} from '../forms/sagas';
import {fetchUserModelSaga, watchUserAccessTokenSetting} from '../user/sagas';
import {navigationFetchConfigSaga} from '../navigation/sagas';
import {fetchModelConfigSaga} from '../model-configs/sagas';
import {notificationsSaga} from '../notifications/sagas';
import {featuresSaga} from '../features/sagas';
import {chatSagas} from '@src/_redux/chats/sagas';
import {articlesSaga} from '@src/_redux/articles/sagas';

export default function* rootSaga() {
    yield all([
        appSagasWatchers(),

        watchUserAccessTokenSetting(),
        fetchUserModelSaga(),

        fetchApiRoutesSaga(),
        fetchClientRoutesSaga(),
        fetchLocalisationsSaga(),
        formsFetchConfigsSaga(),
        navigationFetchConfigSaga(),
        notificationsSaga(),

        fetchModelConfigSaga(),
        featuresSaga(),

        chatSagas(),
        articlesSaga(),
    ]);
}
